import { type FunctionComponent } from "react";
import { Card, Tabs } from "antd";
import { type TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { RequestStatus } from "@fitness-app/app-store";

import { useSideTabsPosition } from "~/hooks/useIsMobile";
import { useQuery } from "~/hooks/useQuery";
import CheckoutSettings from "~/modules/Products/ProductsSettings/CheckoutSettings/CheckoutSettings";
import ConversionTracking from "~/modules/Products/ProductsSettings/ConversionTracking/ConversionTracking";
import EmailClients from "~/modules/Products/ProductsSettings/EmailClients/EmailClients";
import InvoicesClientsPanel from "~/modules/Products/ProductsSettings/Invoices/InvoicesClientsPanel";
import PaymentGateways from "~/modules/Products/ProductsSettings/PaymentGateways/PaymentGateways";
import { useAppSelector } from "~/store/initializeStore";
import AdditionalIntegrations from "./Additionalntegrations/AdditionalIntegrations";

const creatorTabs = (t: TFunction<"settings">) => [
  <Tabs.TabPane tab={t("emailClients.title")} key="email-clients">
    <EmailClients />
  </Tabs.TabPane>,
  <Tabs.TabPane tab={t("payments.title")} key="payment-gateways">
    <PaymentGateways />
  </Tabs.TabPane>,
  <Tabs.TabPane tab={t("invoices.title")} key="invoices-settings">
    <InvoicesClientsPanel />
  </Tabs.TabPane>,
  <Tabs.TabPane tab={t("checkout.title")} key="checkout-settings">
    <CheckoutSettings />
  </Tabs.TabPane>,
  <Tabs.TabPane tab={t<string>("conversionTracking.title")} key="conversion-tracking">
    <ConversionTracking />
  </Tabs.TabPane>,
  <Tabs.TabPane tab={t<string>("additionalIntegrations.title")} key="additional-integrations">
    <AdditionalIntegrations />
  </Tabs.TabPane>,
];

const ProductsSettings: FunctionComponent = () => {
  const { t } = useTranslation("settings");
  const { status } = useAppSelector((state) => state.productsSettings);
  const query = useQuery();
  const sideTabsPosition = useSideTabsPosition();

  const getDefaultKey = () => {
    if (query.get("discord") || query.get("integration") === "discord") {
      return "additional-integrations";
    }
    if (query.get("integration") === "stripe") {
      return "payment-gateways";
    }
    return undefined;
  };

  return (
    <Card bordered={false} loading={status === RequestStatus.SUBSCRIBING}>
      <Tabs tabPosition={sideTabsPosition} defaultActiveKey={getDefaultKey()}>
        {creatorTabs(t)}
      </Tabs>
    </Card>
  );
};

export default ProductsSettings;
